import { useMemo, useState } from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import { computeVolatility } from '../../../engine/volatility';

export function VolatilityPanel() {
  const [history, setHistory] = useState<number[]>(Array.from({length:30},(_,i)=> 60+Math.sin(i/5)*5+Math.random()*3));
  const vol = useMemo(()=> computeVolatility(history), [history]);
  const data = history.map((p,i)=> ({ d: i+1, p }));
  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">Carbon Market Volatility</div>
      <div className={`text-sm ${vol.band==='high'?'text-red-400':vol.band==='medium'?'text-yellow-400':'text-emerald-400'}`}>Band: {vol.band} (stdev: {vol.stdev})</div>
      <div className="w-full h-48">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#1f2937" />
            <XAxis dataKey="d" stroke="#d4af37" />
            <YAxis stroke="#d4af37" />
            <Tooltip contentStyle={{ background:'#000', border:'1px solid #00FF88', color:'#fff' }} />
            <Line type="monotone" dataKey="p" stroke="#00FF88" dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default VolatilityPanel;



















